<template>
  <div>
    <b-modal id="bv-modal-werehouses" size="lg" no-close-on-backdrop>
      <template #modal-header>
        <p class="table-text">
          {{ form.id === null ? $t("create_warehouse") : $t("edit_warehouse") }}
        </p>
        <b-button
          size="sm"
          variant="outline-light"
          class="ml-auto"
          @click="$bvModal.hide('bv-modal-werehouses')"
        >
          <i class="fas fa-times"></i>
        </b-button>
      </template>
      <form @submit.prevent>
        <b-row>
          <b-col md="6" sm="12">
            <div class="row">
              <div class="col-md-12">
                <base-input
                  required
                  :label="$t('name')"
                  :placeholder="$t('name')"
                  input-classes="form-control-alternative border"
                  v-model="form.name"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  :data-vv-as="$t('name')"
                  name="name"
                  autocomplete="off"
                />
                <span class="text-danger text-sm" v-show="errors.has('name')"
                  ><small>{{ errors.first("name") }}</small></span
                >
              </div>
              <div class="col-md-12">
                <base-input :label="$t('address')">
                  <GmapAutocomplete
                    @place_changed="setPlace"
                    class="form-control"
                    id="address"
                    :value="form.address"
                  />
                  <span class="text-danger text-sm" v-show="valid"
                    ><small>{{ $t("required_address") }}</small></span
                  >
                </base-input>
              </div>
               <div class="col-md-12">
                <base-input :label="$t('country')">
                  <v-select
                    class="form-control-alternative border bg-white p-2 rounded"
                    v-model="form.country"
                    :placeholder="$t('country')"
                    autocomplete="ÑÖcompletes"
                    :options="countriesOptions"
                    data-vv-validate-on="blur"
                    v-validate="'required'"
                    :data-vv-as="$t('country')"
                    @input="updateCities(form.country.value)"
                    name="country"
                  >
                    <template #no-options="{}">
                      {{ $t("fail") }}
                    </template>
                  </v-select>
                </base-input>
                <span class="text-danger text-sm" v-show="errors.has('country')"
                  ><small>{{ errors.first("country") }}</small></span
                >
              </div>
              <div class="col-md-12">
                <base-input :label="$t('city')">
                  <v-select
                    class="form-control-alternative border bg-white p-2 rounded"
                    v-model="form.city"
                    autocomplete="ÑÖcompletes"
                    :placeholder="$t('city')"
                    :options="citiesOptions"
                    name="city"
                    data-vv-validate-on="blur"
                    v-validate="'required'"
                    :data-vv-as="$t('city')"
                  >
                    <template #no-options="{}">
                      {{ $t("fail") }}
                    </template>
                  </v-select>
                </base-input>
                <span class="text-danger text-sm" v-show="errors.has('city')"
                  ><small>{{ errors.first("city") }}</small></span
                >
              </div>
            </div>
          </b-col>
          <b-col md="6" sm="12">
            <div>
              <GmapMap
                :center="center"
                :zoom="12"
                style="width: 100%; height: 400px"
              >
              </GmapMap>
            </div>
          </b-col>
        </b-row>
      </form>
      <template #modal-footer>
        <b-button
          size="sm"
          variant="primary"
          @click="add"
          :disabled="valid ? true : false"
        >
          {{ $t("save") }}
        </b-button>
        <b-button
          size="sm"
          variant="secondary"
          @click="$bvModal.hide('bv-modal-werehouses')"
        >
          {{ $t("close") }}
        </b-button>
      </template>
    </b-modal>
    <div></div>
  </div>
</template>
 <script>
import { mapActions, mapGetters } from "vuex";
export default {
  async mounted() {
    await this.getCountries();
    this.geolocate();
  },
  watch: {
    "form.address": {
      handler() {
        if (this.form.address) {
          this.valid = 0;
        } else {
          this.valid = 1;
        }
      },
    },
  },
  data() {
    return {
      form: {
        id: null,
        company: this.$route.params.id,
        name: "",
        address: "",
        country: "",
        city: "",
        longitude: 0,
        latitude: 0,
      },
      valid: 1,
      center: { lat: 45.508, lng: -73.587 },
    };
  },
  methods: {
    ...mapActions({
      getCountries: "config/getCountry",
      getCities: "config/getCities",
      createWerehouse: "werehouse/createWerehouse",
    }),
    async setPlace(place) {
      if(place.address_components.length == 4){
        const country = place.address_components[3]
        const region = place.address_components[0]
        let res = await this.countriesOptions.find(vm => vm.iso === country.short_name)
        this.form.country = res
        await this.updateCities(res.value)
        let city = await this.citiesOptions.find(vm => vm.label == region.long_name)
        this.form.city = city
      }
      this.center = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      this.form.longitude = place.geometry.location.lng();
      this.form.latitude = place.geometry.location.lat();
      this.form.address = place.formatted_address;
    },
    geolocate() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },
    showModal(item) {
      if (item) {
        this.form = {
          id: item.id,
          company: this.$route.params.id,
          name: item.name,
          address: item.address,
          country: {
            label: item.city.country.name,
            value: item.city.country.id,
          },
          city: { label: item.city.name, value: item.city.id },
          longitude: item.longitude,
          latitude: item.latitude,
        };
        this.center = {
          lat: parseFloat(item.latitude),
          lng: parseFloat(item.longitude),
        };
      } else {
        this.form = {
          id: null,
          company: this.$route.params.id,
          name: "",
          address: "",
          country: "",
          city: "",
          longitude: "",
          latitude: "",
        };
      }
      this.$bvModal.show("bv-modal-werehouses");
    },
    async updateCities(id) {
      await this.getCities(id);
    },
    async add() {
      try {
        const validation = await this.$validator.validateAll();
        if (validation) {
          const payload = {
            id: this.form.id ? this.form.id : "",
            company_id: this.$route.params.company
              ? this.$route.params.company
              : this.$route.params.id,
            name: this.form.name,
            address: this.form.address,
            city_id: this.form.city ? this.form.city.value : "",
            latitude: this.form.latitude,
            longitude: this.form.longitude,
          };
          const res = await this.createWerehouse(payload);
          this.$toast.success(res.message, {
            position: "top-right",
          });
          this.$bvModal.hide("bv-modal-werehouses");
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    ...mapGetters({
      countries: "config/countries",
      cities: "config/cities",
    }),
    countriesOptions() {
      if (this.countries) {
        if (this.countries.data) {
          return this.countries.data.map(({ id: value, name: label, iso: iso }) => ({
            value,
            label,
            iso
          }));
        }
      }
      return [];
    },
    citiesOptions() {
      if (this.cities) {
        if (this.cities.data) {
          return this.cities.data.map(({ id: value, name: label }) => ({
            value,
            label,
          }));
        }
      }
      return [];
    },
  },
};
</script>
<style>
.vs__dropdown-toggle {
  border: none;
}
.vs__search {
  color: rgb(189, 189, 189);
}
.vti__input::-webkit-input-placeholder {
  color: rgb(189, 189, 189) !important;
}
.vs__selected {
  color: grey !important;
}
.pac-container {
  z-index: 2001 !important;
}
</style>